export default "__VITE_ASSET__CPOW5WbB__"